import React, { useContext, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { RegularButton as Button, Adaptive } from 'fronton-react';
import { DataContext } from 'entries/common/widgets/project-configuration/context';
import { catalogueLevels, formNames } from '../../const';
import { isLaminate } from '../../helpers/is-laminate';

const ProjectConfigurationFooter = ({ wide }: { wide?: boolean }) => {
  const data = useContext(DataContext);
  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const isLaminateType = isLaminate(data!.type);
  const currentValues = watch();
  const isNotValid = isLaminateType
    ? Boolean(errors?.length)
    : Object.values(currentValues).every(value => value === null || value.length === 0);
  const buttonText = useMemo(() => {
    if (isLaminateType) {
      return 'Подобрать';
    }

    return data?.catalogueLevel === catalogueLevels.THIRD ? 'Применить' : 'Выбрать тип двери';
  }, [isLaminateType, data?.catalogueLevel]);

  return (
    <Button
      data-testid="save-configuration-button"
      size="l"
      disabled={isNotValid}
      wide={wide}
      variant="primary"
      label={buttonText}
      type="submit"
      form={isLaminateType ? formNames.LAMINATE : formNames.INTERIOR_DOORS}>
      {buttonText}
    </Button>
  );
};

export const Footer = () => (
  <>
    <Adaptive to="tablet">
      <ProjectConfigurationFooter wide />
    </Adaptive>
    <Adaptive from="tablet">
      <ProjectConfigurationFooter />
    </Adaptive>
  </>
);
